export const FETCH_SALES_EVENTS_REQUESTED = 'FETCH_SALES_EVENTS_REQUESTED'
export const FETCH_SALES_EVENTS_SUCCEEDED = 'FETCH_SALES_EVENTS_SUCCEEDED'
export const FETCH_SALES_EVENTS_FAILED = 'FETCH_SALES_EVENTS_FAILED'

export const FETCH_SALES_EVENT_TYPES_REQUESTED = 'FETCH_SALES_EVENT_TYPES_REQUESTED'
export const FETCH_SALES_EVENT_TYPES_SUCCEEDED = 'FETCH_SALES_EVENT_TYPES_SUCCEEDED'
export const FETCH_SALES_EVENT_TYPES_FAILED = 'FETCH_SALES_EVENT_TYPES_FAILED'

export const SET_ACTIVE_EVENT_ID = 'SET_ACTIVE_EVENT_ID'

export const fetchSalesEvents = () => ({
  type: FETCH_SALES_EVENTS_REQUESTED,
})

export const fetchSalesEventsSucceeded = (payload) => ({
  type: FETCH_SALES_EVENTS_SUCCEEDED,
  payload,
})

export const fetchSalesEventsFailed = (payload) => ({
  type: FETCH_SALES_EVENTS_FAILED,
  payload,
})

export const fetchSalesEventTypes = () => ({
  type: FETCH_SALES_EVENT_TYPES_REQUESTED,
})

export const fetchSalesEventTypesSucceeded = (payload) => ({
  type: FETCH_SALES_EVENT_TYPES_SUCCEEDED,
  payload,
})

export const fetchSalesEventTypesFailed = (payload) => ({
  type: FETCH_SALES_EVENT_TYPES_FAILED,
  payload,
})

export const setActiveEventId = (eventId) => ({
  type: SET_ACTIVE_EVENT_ID,
  payload: { eventId }
})
